/* eslint-disable @typescript-eslint/no-magic-numbers */
import Vue from 'vue';
import dom from './AssistantModalDom.vue';
import { eventBus } from '../../mixins/StayStrategyMixin';

const AssistantConstructor = Vue.extend(dom);
const pool: Array<any> = [];

const getAnInstance = () => {
  if (pool.length > 0) {
    const instance = pool[0];
    pool.splice(0, 1);
    return instance;
  }
  return new AssistantConstructor({
    el: document.createElement('div'),
  });
};

const returnAnInstance = (instance: any) => {
  if (instance) {
    pool.push(instance);
  }
};

const removeDom = (event: any) => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

const AssistantModal = () => {
  const instance = getAnInstance();
  document.body.appendChild(instance.$el);

  instance.init = function(data: any) {
    instance.strategyData = data;
  };

  instance.show = function(val: string) {
    instance.visible = true;
  };
  instance.longTouch = function() {
    if (!instance.strategyData.assistants.qr_url) return;

    eventBus.$emit('track', 'landingpage_free_popup_press_save', {
      button_name: '长按识别',
      trigger_method: instance.strategyData.triggerMethod,
    });
  };

  return instance;
};

export default AssistantModal();
